// extracted by mini-css-extract-plugin
export default {"GateBody":"text_GateBody__DP+bv","TextArea":"text_TextArea__P-DKx","SettingsContainer":"text_SettingsContainer__+P7d1","SwitchContainer":"text_SwitchContainer__MtfTz"};